<script setup lang="ts">
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import type HotelPriceClass from '@itinerary/hotel/HotelPriceClass';

defineProps<{
    item: HotelPriceClass;
    breakDownRoomPrices: {
        payable: string;
        undiscounted: string | undefined;
        date: string;
    }[];
    nights: number;
}>();
</script>
<template>
    <div class="price-container">
        <mr-price-re
            v-if="item.discountedPrice"
            type="discount"
            :price="item.discountedPrice"
            class="flex-wrap"
            :percent="item.percent"
        />
        <div class="price">
            <mr-price-re
                type="medium"
                :prefix="`${nights} شب`"
                class="flex-wrap"
                :price="item.singlePayable"
            />
            <div class="price-info-icon">
                <mr-icon
                    v-if="item.breakDownRoomPrices.length"
                    :icon="faCircleInfo"
                    color="var(--blue-400)"
                />
                <div class="info-wrapper">
                    <div
                        v-for="bd in breakDownRoomPrices"
                        :key="bd.date"
                        class="info"
                    >
                        <mr-typography
                            size="small"
                            weight="700"
                            color="var(--blue-700)"
                            grow
                        >
                            {{ bd.date }}
                        </mr-typography>
                        <div class="info-price">
                            <mr-typography
                                v-if="bd.undiscounted"
                                type="del"
                                size="small"
                                weight="500"
                                color="var(--red-400)"
                            >
                                {{ bd.undiscounted }}
                            </mr-typography>
                            <mr-typography
                                size="small"
                                weight="500"
                                color="var(--blue-700)"
                                type="span"
                                class="price"
                            >
                                {{ bd.payable }}
                            </mr-typography>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.flex-wrap {
    flex-wrap: wrap;
}
.price-container {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    @include mobile-only {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        flex-basis: 100%;
        max-width: 100%;
    }
    .price {
        display: flex;
        white-space: nowrap;
        align-items: center;
        .price-info-icon {
            position: relative;
            .info-wrapper {
                display: none;
            }
            &:focus,
            &:hover {
                .info-wrapper {
                    display: flex;
                    flex-direction: column;
                    transform: translateX(180px);
                    z-index: 1;
                    border-radius: 12px;
                    position: absolute;
                    width: 210px;
                    background-color: white;
                    @include shadow();
                    padding: 12px;
                    .info {
                        display: flex;
                        .info-price {
                            display: flex;
                            .price {
                                margin-right: 8px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
